import React from "react";
import moment from "moment";
import styled from "styled-components";

interface IPreviousNoticeListItemProps {
  notice: any;
  onSelect: (notice: any) => void;
}

const PreviousNoticeListItem = ({ notice, onSelect }: IPreviousNoticeListItemProps) => {
  return (
    <NoticeItemContainer onClick={() => onSelect(notice)}>
      <div className="top-area">
        <span className="cate">{notice.cate_name}</span>
        {notice.end_date && <span className="end-date">{moment(notice.end_date).format("YYYY.MM.DD")} 마감</span>}
      </div>
      <p className="title">{notice.title}</p>
      <div className="add-info">
        <div>
          <span className="name">{notice.vmd_name}</span>
          <span className="date">{moment(notice.insert_date).format("YYYY.MM.DD")}</span>
        </div>
      </div>
    </NoticeItemContainer>
  );
};

const NoticeItemContainer = styled.div`
  padding: 16px 0;
  border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.color.bgPrimary};
  }

  .top-area {
    ${({ theme }) => theme.flexBox.flexMixin()}
    .cate {
      color: ${({ theme }) => theme.color.tertiary};
      font-weight: 500;
      line-height: 20px;
    }
    .end-date {
      color: ${({ theme }) => theme.color.warning};
      font-weight: 400;
      line-height: 20px;
      font-family: "Poppins";
    }
  }

  .title {
    ${({ theme }) => theme.textOverflow.singleLine()}
    margin-top: 10px;
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    & + .add-info {
      margin-top: 9px;
    }
  }

  .add-info {
    ${({ theme }) => theme.flexBox.flexMixin()}
    color: ${({ theme }) => theme.color.tertiary};
    font-weight: 500;
    line-height: 20px;
    .date {
      padding-left: 16px;
      font-family: "Poppins";
      font-weight: 400;
    }
  }
`;

export default PreviousNoticeListItem;